import language from "../../language";
import toastMessage from "../toastMessage";
import api from "../api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

export const fetchEntityCategories = async (lng = "english", params = {}) => {
  try {
    if (!params.q) {
      delete params.q;
    }

    const options = {
      method: "GET",
      url: `${API_URL}/entityCategory`,
      params,
    };

    const queryRes = await api(options);
    let data = queryRes?.data?.data || queryRes?.data || [];
    let count = queryRes?.data?.totalRecords;

    if (params.inputType === "dropdown") {
      return (Array.isArray(data) ? data : []).map((el) => ({
        ...el,
        label: el.name,
        value: el._id,
      }));
    }

    return !params.page && !params.limit ? data : { data, count, totalRecords: count };
  } catch (error) {
    toastMessage("error", error);
    return params.inputType === "dropdown" ? [] : { data: [], count: 0 };
  }
};

export const addEntityCategory = async (data) => {
  try {
    const method = data.id ? "PUT" : "POST";
    const options = {
      method,
      url: `${API_URL}/entityCategory`,
      data,
    };

    const queryRes = await api(options);
    return queryRes.data;
  } catch (error) {
    toastMessage("error", error);
  }
};

export const deleteEntityCategory = async (lng = "english", id) => {
  try {
    const options = {
      method: "DELETE",
      url: `${API_URL}/entityCategory`,
      data: { id },
    };

    await api(options);
    toastMessage("success", language[lng].delete_data_success);
  } catch (error) {
    toastMessage("error", error);
  }
};
